import { ProfileTypes } from './types';

interface ProfileProps {
  login?: string;
  senha?: string;
  refresh?: boolean;
  tabId: string;
}

export const profileSignOut = () => ({
  types: [ProfileTypes.LOGOUT_REQUEST, ProfileTypes.LOGOUT_SUCCESS, ProfileTypes.LOGOUT_FAILURE],
  promise: (client: any) =>
    client.delete('users/logout', { body: { new_site: true } }).then((response: any) => {
      // sem resposta (falha de rede) o interceptor devolve undefined, que o middleware trataria como sucesso
      if (!response) throw new Error('Logout sem resposta do servidor');

      return response;
    }),
});

export const profileSignIn = ({ login, senha, tabId, refresh = false }: ProfileProps) => ({
  types: [ProfileTypes.SHOW_REQUEST, ProfileTypes.SHOW_SUCCESS, ProfileTypes.SHOW_FAILURE],
  promise: (client: any) => client.post('users/login.json', { login, senha, refresh }),
  rest: refresh,
  tabId,
});

export const refreshProfile = () => ({
  types: [
    ProfileTypes.REFRESH_PROFILE_REQUEST,
    ProfileTypes.REFRESH_PROFILE_SUCCESS,
    ProfileTypes.REFRESH_PROFILE_FAILURE,
  ],
  promise: (client: any) => client.post('users/login.json', { refresh: true }),
  rest: true,
});

export const register = (params: object) => ({
  types: [
    ProfileTypes.REGISTER_REQUEST,
    ProfileTypes.REGISTER_SUCCESS,
    ProfileTypes.REGISTER_FAILURE,
  ],
  promise: (client: any) => client.post('/api/clients/signups', { params }),
  rest: true,
});

export const registerConlicitaseg = (params: object) => ({
  types: [
    ProfileTypes.REGISTER_REQUEST,
    ProfileTypes.REGISTER_SUCCESS,
    ProfileTypes.REGISTER_FAILURE,
  ],
  promise: (client: any) => client.post('/api/clients/conlicitaseg_signups', { params }),
  rest: true,
});

export const passwordNew = (email: string) => ({
  types: [
    ProfileTypes.PASSWORD_NEW_REQUEST,
    ProfileTypes.PASSWORD_NEW_SUCCESS,
    ProfileTypes.PASSWORD_NEW_FAILURE,
  ],
  promise: (client: any) => client.post('/usuarios/password', { email }),
  rest: true,
});

export const passwordEdit = (reset_password_token: string | null) => ({
  types: [
    ProfileTypes.PASSWORD_EDIT_REQUEST,
    ProfileTypes.PASSWORD_EDIT_SUCCESS,
    ProfileTypes.PASSWORD_EDIT_FAILURE,
  ],
  promise: (client: any) =>
    client.get(`/usuarios/password/edit?reset_password_token=${reset_password_token}`),
  rest: true,
});

export const passwordUpdate = (
  password: string,
  password_confirmation: string,
  reset_password_token: string | null,
) => ({
  types: [
    ProfileTypes.PASSWORD_UPDATE_REQUEST,
    ProfileTypes.PASSWORD_UPDATE_SUCCESS,
    ProfileTypes.PASSWORD_UPDATE_FAILURE,
  ],
  promise: (client: any) =>
    client.put('/usuarios/password', { password, password_confirmation, reset_password_token }),
  rest: true,
});

export const invitation = (invitation_token: string | null) => ({
  types: [
    ProfileTypes.INVITATION_REQUEST,
    ProfileTypes.INVITATION_SUCCESS,
    ProfileTypes.INVITATION_FAILURE,
  ],
  promise: (client: any) =>
    client.get(`/usuarios/invitation/accept?invitation_token=${invitation_token}`),
  rest: true,
});

export const invitationUpdate = (
  password: string,
  password_confirmation: string,
  invitation_token: string | null,
) => ({
  types: [
    ProfileTypes.INVITATION_UPDATE_REQUEST,
    ProfileTypes.INVITATION_UPDATE_SUCCESS,
    ProfileTypes.INVITATION_UPDATE_FAILURE,
  ],
  promise: (client: any) =>
    client.put('/usuarios/invitation', {
      usuario: { invitation_token, password, password_confirmation },
    }),
  rest: true,
});
